const FontSizeClass = ['font25', 'font50', 'font100', 'font150', 'font200'];
const fontSetStore = {
  state: {
    sizeFonts: 0,
    fontSizeClass: 'font100',
  },
  mutations: {
    SET_FONT_SIZE(state, size) {
      state.sizeFonts = size;
    },
    SET_FONT_SIZE_CLASS(state, size) {
      state.fontSizeClass = size;
    },
  },
  actions: {
    setFontSize({ commit }, size) {
      commit('SET_FONT_SIZE', size);
    },
    setFontSizeClass({ commit }, index = 2) {
      commit('SET_FONT_SIZE_CLASS', FontSizeClass[index]);
    },
    changeFontSize({ state }, data) {
      const { size, lineHeight } = data;
      let result = {
        size,
        lineHeight
      };
      if (state.sizeFonts === 0.5) {
        result.size = 26;
        result.lineHeight = 29;
      } else if (state.sizeFonts === 1) {
        result.size = 32;
        result.lineHeight = 34;
      }
      return result;
    }
  }
};

export default fontSetStore;
